//REDUX-TOOLKIT
import { createSlice, PayloadAction } from "@reduxjs/toolkit";


interface State {
    data: object[]
}

const initialState: State = {
    data: []
}


const slice = createSlice({
    name: "legalcontent",
    initialState,
    reducers: {
        setLegalcontent: (state, action: PayloadAction<any>) => {
            return { ...state, data: action.payload }
        }
    }
})


export const { setLegalcontent } = slice.actions;
export const selectLegalcontent = (state: { legalcontent: State }) => state.legalcontent.data;
export default slice.reducer;